export class OrganizationAdminUpdateResult
{
    Info!: string;

    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }
}
